// extracted by mini-css-extract-plugin
module.exports = {"base":"Divider-module-base","fullWidth":"Divider-module-full-width","text":"Divider-module-text","children":"Divider-module-children"};